import React, { useState } from "react";
import MarketingNav from "@/components/site/MarketingNav";
import Footer from "@/components/site/Footer";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";
import { Mail, MapPin, Send } from "lucide-react";

export default function Contact() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  function handleSubmit(e) {
    e.preventDefault();
    const subject = encodeURIComponent(`Draftwave — message from ${name || "a friend"}`);
    const bodyText = encodeURIComponent(
      `${message}\n\n— ${name || ""}${email ? ` <${email}>` : ""}`
    );
    window.location.href = `mailto:info@draftwave.online?subject=${subject}&body=${bodyText}`;
    toast.success("Opening your email client…");
  }

  return (
    <div className="min-h-screen bg-background" data-testid="contact-page">
      <MarketingNav />
      <section className="border-b border-border">
        <div className="max-w-[1400px] mx-auto grid grid-cols-1 md:grid-cols-12">
          <div className="md:col-span-5 border-r border-border p-8 md:p-16">
            <div className="overline text-muted-foreground">Contact</div>
            <h1 className="font-serif-display text-5xl md:text-6xl leading-none tracking-tight mt-4">
              Say hello.
              <br />
              We reply
              <br />
              <span className="italic text-primary">personally.</span>
            </h1>
            <div className="mt-10 space-y-6 text-sm">
              <div>
                <div className="overline text-muted-foreground flex items-center gap-2">
                  <Mail className="w-3 h-3" /> Email
                </div>
                <a
                  href="mailto:info@draftwave.online"
                  className="font-mono text-primary hover:underline mt-2 inline-block"
                  data-testid="contact-email-link"
                >
                  info@draftwave.online
                </a>
              </div>
              <div>
                <div className="overline text-muted-foreground flex items-center gap-2">
                  <MapPin className="w-3 h-3" /> Mailing address
                </div>
                <div className="font-mono mt-2 leading-relaxed">
                  Draftwave Editorial Co.
                  <br />
                  11642 Victory Blvd, Unit 2032
                  <br />
                  North Hollywood, CA 91606
                </div>
              </div>
              <div>
                <div className="overline text-muted-foreground">Response time</div>
                <div className="font-mono mt-2">Usually within one business day.</div>
              </div>
            </div>
          </div>
          <div className="md:col-span-7 p-8 md:p-16">
            <div className="overline text-muted-foreground">Send a note</div>
            <form onSubmit={handleSubmit} className="mt-6 space-y-4 max-w-xl" data-testid="contact-form">
              <div>
                <label className="overline text-muted-foreground">Name</label>
                <Input
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  placeholder="Your name"
                  required
                  className="rounded-none mt-2 h-11 font-mono text-sm"
                  data-testid="contact-name"
                />
              </div>
              <div>
                <label className="overline text-muted-foreground">Email</label>
                <Input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="you@company.com"
                  required
                  className="rounded-none mt-2 h-11 font-mono text-sm"
                  data-testid="contact-email"
                />
              </div>
              <div>
                <label className="overline text-muted-foreground">Message</label>
                <Textarea
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  placeholder="What's on your mind?"
                  required
                  className="rounded-none mt-2 min-h-[160px] font-mono text-sm"
                  data-testid="contact-message"
                />
              </div>
              <Button
                type="submit"
                className="rounded-none h-12 px-8 font-mono uppercase tracking-widest text-xs"
                data-testid="contact-submit-btn"
              >
                <Send className="w-4 h-4" /> Send message
              </Button>
            </form>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
